import React, { FC, useRef, useState } from "react";
import cn from "clsx";
import ModalBFL from "../modal/modal";
import { useIsRTL } from "../../hooks";
import { DialogModalProps } from "./type";
import { useAppSelector } from "@/redux/store";
import { selectSettings } from "@/util/selectors";
import { TurnstileCaptcha, TurnstileCaptchaRef } from "../captcha/captcha";
import { ButtonWithLoader } from "../common/buttons";

const DialogModal: FC<DialogModalProps> = ({
  titleText,
  bodyText,
  confirmButtonText,
  cancelButtonText,
  showModal,
  onCancel,
  onConfirm,
  classname,
  showCaptcha,
  parentCaptchaRef
}) => {
  const isRTL = useIsRTL();
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const [isInteractiveCaptcha, setIsInteractiveCaptcha] = useState(false);
  const turnstileCaptchaToken = useAppSelector(
    state => state.authReducer.turnstileCaptchaToken
  );
  const settings = useAppSelector(selectSettings);
  const valueCaptchaFromCMS = settings?.captcha?.userRegisterScreen;
  const captchaRef = useRef<TurnstileCaptchaRef>(null);
  const isAutomaticCaptcha =
    showCaptcha &&
    !captchaLoading &&
    !isInteractiveCaptcha &&
    valueCaptchaFromCMS &&
    !turnstileCaptchaToken;
  const shouldShowLoader = isAutomaticCaptcha || captchaLoading;

  return (
    <ModalBFL
      showModal={showModal}
      modalClass={cn("generic_modal dialog_modal", {
        arabic: isRTL,
        [classname]: !!classname
      })}
      closeModal={onCancel}
      overlayClassName="dialog_modal"
    >
      <div className="dialog_modal_content">
        {titleText && <h4>{titleText}</h4>}
        {bodyText && <p>{bodyText}</p>}
        {valueCaptchaFromCMS && showCaptcha && (
          <TurnstileCaptcha
            ref={captchaRef}
            className="mt-4 mb-4"
            beforeLoading={() => setCaptchaLoading(true)}
            afterLoading={() => {
              setCaptchaLoading(false);
            }}
            onInterectiveChallangeStarted={() => {
              setIsInteractiveCaptcha(true);
            }}
            onToken={() => setCaptchaLoading(false)}
            onTokenExpired={() => setCaptchaLoading(false)}
          />
        )}
        <div className="action_btn">
          <button
            onClick={() => {
              onCancel?.();
              showCaptcha && parentCaptchaRef?.current?.reset();
            }}
          >
            {cancelButtonText}
          </button>
          {confirmButtonText && (
            <ButtonWithLoader
              onClick={() => {
                onConfirm?.();
                showCaptcha && parentCaptchaRef?.current?.reset();
              }}
              showLoaderWithoutClick
              showLoader={shouldShowLoader}
              disabled={shouldShowLoader}
            >
              {confirmButtonText}
            </ButtonWithLoader>
          )}
        </div>
      </div>
    </ModalBFL>
  );
};

export default DialogModal;
